
const _ = require('lodash');

const vb = require('../definition');

const {
	unwrap,
} = require('../util');

vb.everyFileHasAllowedExtensions = (allowedExtensions, message) => {
	return {
		validator: v => {
			return _.every(v, f => {
				const file = unwrap(f);
				const fileName = file && file.Name();
				return !fileName
					|| _.some(allowedExtensions, ext => {
						const extension = unwrap(ext).toLowerCase();
						return fileName.toLowerCase().endsWith(`.${extension}`);
					});
			});
		},
		message: message || [
			`поддерживаются только следующие форматы: .${allowedExtensions.join(', .')}`,
			`только .${allowedExtensions.join(', .')}`,
			'недопустимый формат файла',
		],
	};
};